const BASE_PATH = '/v1/manu/online-reporting';

export const GetManuOnlineReporting = (): string => BASE_PATH;
